
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[...param]",
      function () {
        return require("private-next-pages/news/[...param].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[...param]"])
      });
    }
  